<script>
import Chat from "./Chat";

const axios = require('axios').default;

export default {

  name: 'ChatViewer',

  components: {Chat},

  mixins: [axios],

  props: {
    route: {
      required: true,
      type: String,
    },
    messagesInitial: {
      required: false,
      type: Array,
      default: function () {
        return [];
      }
    },
    channelId: {
      required: false,
      type: String,
      default: null,
    },
    chatEnabledInfo: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      objective: {
        county_fips: null,
        is_aging: null,
      },
      unsavedCounty: null,
      unsavedIsAging: null,
      counties: {},
      errors: {
        aging: false,
        county: false
      }
    };
  },

  watch: {
    'objective': {
      handler: function () {
        if (this.objective.is_aging !== null){
          this.unsavedIsAging = this.objective.is_aging;
        }
        if (this.objective.county_fips !== null){
          this.unsavedCounty = this.objective.county_fips;
        }
        if (this.hasObjective) {
          this.setObjective()
        }
      },
      deep: true
    }
  },

  computed: {
    hasObjective() {
      // User has specified the county and resource they are looking for.
      return (this.objective.county_fips !== null && this.objective.is_aging !== null)
    },
  },

  created() {
    this.getCounties()
    this.getObjective()
    console.log(this.hasObjective ? 'We have an objective' : 'We do NOT an objective')
  },

  methods: {
    validateForm(e){
      e.preventDefault();

      //reset all errors
      this.errors.aging = false;
      this.errors.county = false;

      let hasErrors = false;
      if(this.unsavedIsAging === null) {
        hasErrors = true;
        this.errors.aging = true;
      }

      if(this.unsavedCounty === null) {
        hasErrors = true;
        this.errors.county = true;
      }

      if(hasErrors) {
        return false;
      }

      //form is valid
      this.objective.is_aging = this.unsavedIsAging;
      this.objective.county_fips = this.unsavedCounty;
    },
    getCounties() {
      axios.get('/counties').then((response) => {
        this.counties = response.data
      })
    },
    getObjective() {
      console.log('Fetching Objective from Session')
      //get the user objective from the session
      axios.get('/objective').then((response) => {
        this.objective = response.data
        console.log(this.hasObjective ? 'We have an objective' : 'We do NOT have an objective')
        console.log(this.objective)
      })

    },
    checkSendObjective() {
      if (this.hasObjective) {
        this.setObjective()
      }
    },
    setObjective() {
      axios.post('/objective', this.objective).catch((errors) => {
        console.error('Objective did not get saved to session.')
      });
    },
  },
};

</script>

<template>
  <div class="w-full h-screen flex flex-col bg-white border relative">
    <Chat :route="route"
          :messages-initial="messagesInitial"
          :channelId="channelId"
          :isAuth="false"
          :meta="objective"
          :disabled="!hasObjective"
    ></Chat>

    <div class="w-full text-lg text-gray-600 text-center" v-if="hasObjective">
      Chatting about
        <a href=""
           onclick="return false;"
           class="text-cerulean-default underline"
           @click="objective = {is_aging: null}">
            {{ objective.is_aging ? 'Aging' : 'Disability' }}</a>
      resources content in
      <a href=""
         onclick="return false;"
         class="text-cerulean-default underline"
         @click="objective = {county_fips: null}">
          {{ this.counties[objective.county_fips] }}
      County</a>.
    </div>

    <div class="absolute z-10 bg-black w-full h-screen bg-opacity-50 text-lg" v-show="!hasObjective">
      <div class="md:h-screen flex flex-wrap content-center">
        <div class="bg-white md:w-1/2 xl:w-1/4 text-cerulean-default mx-auto">
          <div class="relative">
            <div class="flex flex-row justify-center bg-gray-100 rounded-concave relative px-10 pt-16 pb-12 z-30">
              <a href="/" target="_blank" rel="noreferrer">
                <img src="images/logo.png" alt="Life Long Links Logo" class="w-56" />
              </a>
            </div>
            <span class="absolute rounded-concave-85 p-2 bg-gray-50 -mt-16 z-20 h-1/2 w-full"></span>
          </div>
          <div v-if="!chatEnabledInfo.chatIsEnabled" class="m-12">
            <div class="flex flex-col mx-auto text-center justify-center mb-6">
            <h1 class="text-3xl">
              Agent Support is currently offline.
            </h1>
            <div class="h-1 bg-gold-default w-1/2 place-self-center my-4"></div>
              <h2 v-if="chatEnabledInfo.hoursOfOperation" class="mb-6 text-2xl">
                Hours of Operation
              </h2>
              <p><span>{{chatEnabledInfo.hoursOfOperation}}</span></p>
              <p v-if="chatEnabledInfo.awayMessage">{{chatEnabledInfo.awayMessage}}</p>

            <div class="h-1 bg-gold-default w-1/2 place-self-center my-4"></div>
            <!--<p class="mb-6 text-2xl">
              Feel free to email us at <a href="mailto:email@site.com" target="_blank" rel="noreferrer" class="font-bold underline">email@site.com</a>
            </p>-->
          </div>
          </div>
          <div v-if="chatEnabledInfo.chatIsEnabled" class="m-12">
            <div class="flex flex-col mx-auto text-center justify-center mb-6">
              <h1 class="text-3xl">
                Let’s find the agent with the expertise <strong>you need.</strong>
              </h1>
              <div class="h-1 bg-gold-default w-1/2 place-self-center my-4"></div>
            </div>

            <form method="post" action="/objective" @submit="validateForm">
              <div class="flex flex-col mx-auto text-center justify-center mb-6">
                <h2 class="mb-6 text-2xl">
                  What type of services are you looking for?
                </h2>
                <div class="mb-6">
                  <label for="aging" class="flex flex-row justify-between items-center bg-white rounded-full border border-gray-100 p-6 shadow-md mb-6 font-bold gap-1 tracking-wide cursor-pointer">
                    Age Related Resources
                    <input type="radio"
                           id="aging"
                           :value="true"
                           v-model="unsavedIsAging"
                           class="transform scale-150" />
                  </label>
                  <label for="disability" class="flex flex-row justify-between items-center bg-white rounded-full border border-gray-100 p-6 shadow-md font-bold gap-1 tracking-wide cursor-pointer">
                    Disability Related Resources
                    <input type="radio"
                           id="disability"
                           :value="false"
                           v-model="unsavedIsAging"
                           class="transform scale-150" />
                  </label>
                  <p class="text-red-700 my-2" v-show="errors.aging"><strong>Please choose a service resource</strong></p>
                </div>

                <h2 class="mb-6 text-2xl">
                  Where are you or your family located?
                </h2>

                <div class="mb-6">
                  <div class="bg-white rounded-full px-4 shadow-md h-12 border border-gray-100">
<!--                    TODO:: implement both county and zipcode search : -->
<!--                    <input list="counties"-->
<!--                           class="w-full my-3 text-center font-bold placeholder-cerulean-default"-->
<!--                           aria-labelledby="counties zipcodes"-->
<!--                           v-model="unsavedCounty"-->
<!--                           placeholder="Zipcode or County" />-->
<!--                    <datalist id="counties"-->
<!--                              class="rounded-full my-auto p-6 w-full">-->
<!--                      <option :value="null">County</option>-->
<!--                        <option v-for="(county,fips) in counties" :id="county" :value="fips">{{ county }}</option>-->
<!--                    </datalist>-->
                    <select v-model="objective.county_fips" class="h-12 rounded-full my-auto py-2 px-4 w-full">
                      <option :value="null">County</option>
                      <template v-for="(county,fips) in counties">
                        <option :value="fips">{{ county }}</option>
                      </template>
                    </select>
                  </div>
                  <p class="text-red-700 my-2" v-show="errors.county"><strong>Please enter a zipcode</strong></p>
                </div>
                <h2 class="mb-6 text-2xl">
                  Email Address:
                </h2>
                <div class="mb-6">
                  <div class="bg-white rounded-full px-4 shadow-md h-12 border border-gray-100">
                    <input name="email" id="email" class="h-12 rounded-full my-auto py-2 px-4 w-full" />
                  </div>
                </div>
                <button type="submit"
                        class="bg-blue-default hover:bg-gold-darker text-white font-semibold py-2 px-4 rounded-full">
                  Start Chat
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
